import React, {  useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import PostRender from "../PostRender";
import { loadPost } from "redux/modules/postSlice";

// 페이지에 게시글5개를 넣어주는것을 만들어야 함
function InfiniteScroll({
  currentCategory,
  currentPage,
  currentPageFunc,
  postsList, // 카테고리별 게시글 목록
  totalLength, // 카테고리별 총 개수
  setPostsListFunc,
}) {
  const dispatch = useDispatch();
  const targetRef = useRef(null);

  const totalPage = Math.ceil(totalLength / 5);

  useEffect(() => {
    const payload = { category: currentCategory, page: currentPage + 1 };
    if (totalPage > currentPage) {
      dispatch(loadPost(payload))
        .unwrap()
        .then((res) => {
          setPostsListFunc(res.data);
        });
    }
  }, [dispatch, currentCategory, currentPage]);

  // 무한스크롤
  const callback = ([entries]) => {
    if (entries.isIntersecting) {
      currentPageFunc();
    }
  };

  useEffect(() => {
    if (!targetRef.current) return;
    const observer = new IntersectionObserver(callback, {
      threshold: 1,
    });

    observer.observe(targetRef.current);
  }, [targetRef]);

  return (
    <>
      {postsList.length > 0 &&
        postsList.map((post) => <PostRender key={post.boardId} post={post} />)}
      {totalPage > currentPage && <div ref={targetRef}>Loading...</div>}
    </>
  );
}

export default InfiniteScroll;
